import { render, staticRenderFns } from "./Club.vue?vue&type=template&id=74f23c48&scoped=true"
var script = {}
import style0 from "./Club.vue?vue&type=style&index=0&id=74f23c48&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f23c48",
  null
  
)

export default component.exports